import { render, staticRenderFns } from "./ExternalDamagePictures.vue?vue&type=template&id=40b337c6&scoped=true"
import script from "./ExternalDamagePictures.vue?vue&type=script&lang=ts"
export * from "./ExternalDamagePictures.vue?vue&type=script&lang=ts"
import style0 from "./ExternalDamagePictures.vue?vue&type=style&index=0&id=40b337c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b337c6",
  null
  
)

export default component.exports